<template>
  <div class="app-container">
    <CrudTable entity="ProductCategory" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['name', 'parentName']
    };
  }
};
</script>

<style scoped></style>
